import script from "./ThemeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeButton.vue?vue&type=script&setup=true&lang=js"

import "./ThemeButton.vue?vue&type=style&index=0&id=dad61ad8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dad61ad8"]])

export default __exports__